import { FaInstagram, FaLinkedin, FaGithub, FaTwitter } from 'react-icons/fa'

const socialLinks = [
  {
    id: 1,
    icon: <FaInstagram />,
    link: 'https://www.instagram.com/avy_raj11',
    title: 'Instagram'
  },
  {
    id: 2,
    icon: <FaTwitter />,
    link: 'https://twitter.com/avy_raj11',
    title: 'Twitter'
  },
  {
    id: 3,
    icon: <FaLinkedin />,
    link: 'https://www.linkedin.com/in/rajgupta2003',
    title: 'LinkedIn'
  },
  {
    id: 4,
    icon: <FaGithub />,
    link: 'https://github.com/code-raj11903',
    title: 'GitHub'
  }
]

export default socialLinks
